import React from "react";
import "./new_card.css";
import QuoteIcon from "./Quotes";
import styled from "styled-components";

const NewCard = ({ title, description,icon }) => {
  return (
    <div className="" style={{display:'flex',justifyContent:'center'}}>

      {/* <div className="card2">
      <div style={{display:'flex',justifyContent:'center',color:"black"}}>        {icon}
      </div>
        <h2>
            {title}</h2>
        <p>{description}</p>
      </div>
      <div className="accents">
        <div className="acc-card"></div>
        <div className="acc-card"></div>
        <div className="acc-card"></div>
        <div className="light"></div>
        <div className="light sm"></div>
        <div className="top-light"></div>
      </div> */}
    <Wrapper className="darkBg radius8 flexNullCenter flexColumn my-card" style={{      backgroundColor: "#2f2f2f",borderRadius:'10px'}}>
            <QuoteWrapper>
        <QuoteIcon />
      </QuoteWrapper>
            <p className="greyColor font13" style={{alignSelf: 'flex-end',color:'white'}}>
        <em>{icon}</em>
      </p>
      <p className="whiteColor font18" style={{ paddingBottom: "10px",fontSize:'18px',fontWeight:'bold',color:'white' }}>
        {title}
      </p>
      <p className=" font13" style={{alignSelf: 'flex-end',textAlign:'center',color:'#b19777',fontWeight:'bold'}}>
        <em>{description}</em>
      </p>

    </Wrapper>
    </div>
  );
};

export default NewCard;
const QuoteWrapper = styled.div`
  position: relative;
  top: -40px;
`;
const Wrapper = styled.div`
  width: 100%;
  max-height:240px;
  height:240px;
  padding: 20px 30px;
  margin-top: 30px;

`;